import React from 'react';
import './SceneSpotGroup.css';
import { TIMELINE } from '../../../content';
import SceneSpot from './SceneSpot/SceneSpot';

const SceneSpotGroup = props => {
  const { type, style } = props;

  // style
  const groupStyle = {};
  if (type === 1) {
    groupStyle.bottom = style.bottom;
  } else {
    groupStyle.top = style.top;
  }

  // set spots
  const spots = [];
  const typeId = type === 1 ? 'top' : 'bottom';
  for (let i = 0; i < TIMELINE.length; i += 1) {
    if (TIMELINE[i].map !== undefined) {
      for (let j = 0; j < TIMELINE[i].map[typeId].length; j += 1) {
        spots.push(
          <SceneSpot
            key={`${i}-${j}`}
            type={type}
            data={TIMELINE[i].map[typeId][j]}
            positionId={i}
          />
        );
      }
    }
  }

  return (
    <div className="scene-spot-group" style={groupStyle}>
      {spots}
    </div>
  );
};

export default SceneSpotGroup;



// WEBPACK FOOTER //
// ./src/components/Shared/SceneSpotGroup/SceneSpotGroup.js